import React, { Component } from 'react';

import Form from '../form';
import InputButton from '../inputs/input-button';
import InputButtonWrapper from '../inputs/input-button-wrapper';
import SimpleTable from '../tables/components/simple-table';

class AccordionFormSimpleTable extends Component {
    constructor(props) {
        super(props);

        this.renderOptionalButtons = this.renderOptionalButtons.bind(this);
    }

    renderOptionalButtons() {
        if (this.props.config.optionalButtonConfig === undefined) {
            return null;
        }

        return (
            <InputButtonWrapper>
                {this.props.config.optionalButtonConfig.buttons.map(button => (
                    <InputButton
                        value={button.value}
                        buttonTheme={button.theme}
                        disabled={button.disabled}
                        onClick={button.onClick}
                    />
                ))}
            </InputButtonWrapper>
        );
    }

    renderOptionalSecondRowButtons = () => {
        if (!this.props.config.optionalSecondRowButtonConfig) {
            return null;
        }

        return (
            <InputButtonWrapper>
                {this.props.config.optionalSecondRowButtonConfig.buttons.map(button => (
                    <InputButton
                        value={button.value}
                        buttonTheme={button.theme}
                        disabled={button.disabled}
                        onClick={button.onClick}
                    />
                ))}
            </InputButtonWrapper>
        );
    };
    render() {
        return (
            <div className="accordion__item-content__form-list" data-testid="form-simple-table">
                <p className="accordion__item-content__form-list__copy">{this.props.config.copy}</p>

                <Form config={this.props.config.formConfig} />

                <SimpleTable
                    header={this.props.config.tableConfig.header}
                    rows={this.props.config.tableConfig.rows}
                    isLoading={this.props.config.tableConfig.isLoading}
                    errorMessageOverride={this.props.config.tableConfig.errorMessageOverride}
                    enableSearch={this.props.config.tableConfig.enableSearch}
                    searchableColumns={this.props.config.tableConfig.searchableColumns}
                    enableFilters={this.props.config.tableConfig.enableFilters}
                    filters={this.props.config.tableConfig.filters}
                    isScrollable={this.props.config.tableConfig.isScrollable}
                    hasEndAction={this.props.config.tableConfig.hasEndAction}
                />

                <this.renderOptionalButtons />
                <this.renderOptionalSecondRowButtons />
            </div>
        );
    }
}

export default AccordionFormSimpleTable;
